import React, { useEffect, useState } from 'react';

import './App.css';
import logo from './images/logo.png';
import favicon from './images/favicon.png';

import ChatTool from './tools/ChatTool';
import TranscriptionTool from './tools/TranscriptionTool';
import loadRuntimeConfig from './api/runtimeConfig';
import { CONTACT_EMAIL, CONTACT_NAME } from './config';

const TABS = [
    { id: 'transcription', label: 'Transkription' },
    { id: 'chat', label: 'Chat' },
];

const THEME_KEY = 'lfo.theme';

function readTheme() {
    try {
        const stored = localStorage.getItem(THEME_KEY);
        if (stored === 'light' || stored === 'dark') return stored;
    } catch {
        /* Storage nicht verfuegbar */
    }
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function App() {
    const [activeTab, setActiveTab] = useState('transcription');
    const [theme, setTheme] = useState(readTheme);
    // null = noch nicht geladen. Bis dahin bleibt der Chat-Reiter aus, damit er
    // nicht kurz aufblitzt, wenn er abgeschaltet ist.
    const [chatEnabled, setChatEnabled] = useState(null);

    useEffect(() => {
        let active = true;
        loadRuntimeConfig().then((config) => {
            if (active) setChatEnabled(config.chatEnabled);
        });
        return () => {
            active = false;
        };
    }, []);

    useEffect(() => {
        document.title = 'LFO Services';

        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/png';
        link.rel = 'shortcut icon';
        link.href = favicon;
        document.head.appendChild(link);
    }, []);

    useEffect(() => {
        document.documentElement.dataset.theme = theme;
        try {
            localStorage.setItem(THEME_KEY, theme);
        } catch {
            /* Storage nicht verfuegbar */
        }
    }, [theme]);

    const visibleTabs = TABS.filter((tab) => tab.id !== 'chat' || chatEnabled);

    // Wird der Chat abgeschaltet, waehrend er offen ist, zurueck zur Transkription.
    useEffect(() => {
        if (chatEnabled === false && activeTab === 'chat') {
            setActiveTab('transcription');
        }
    }, [chatEnabled, activeTab]);

    return (
        <div className="app">
            <header className="app-header">
                <div className="brand">
                    <img src={logo} alt="TU Dortmund" id="logo" />
                    <span className="brand-name">LFO Services</span>
                </div>

                <nav className="tabs" aria-label="Dienste">
                    {visibleTabs.map((tab) => (
                        <button
                            key={tab.id}
                            type="button"
                            onClick={() => setActiveTab(tab.id)}
                            className={activeTab === tab.id ? 'active' : ''}
                            aria-current={activeTab === tab.id ? 'page' : undefined}
                        >
                            {tab.label}
                        </button>
                    ))}
                </nav>

                <button
                    type="button"
                    className="theme-toggle"
                    onClick={() => setTheme((current) => (current === 'dark' ? 'light' : 'dark'))}
                    aria-label={theme === 'dark' ? 'Helles Design' : 'Dunkles Design'}
                    title={theme === 'dark' ? 'Helles Design' : 'Dunkles Design'}
                >
                    {theme === 'dark' ? '☀' : '☾'}
                </button>
            </header>

            <main className="app-main">
                {activeTab === 'transcription' && <TranscriptionTool />}
                {activeTab === 'chat' && chatEnabled && <ChatTool />}
            </main>

            <footer className="app-footer">
                <span>
                    Ansprechpartner: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_NAME}</a>
                </span>
                <span>Lehrstuhl für Unternehmenslogistik · TU Dortmund</span>
            </footer>
        </div>
    );
}

export default App;
